import EventEmitter from "~/js/events";
import type { PageId } from "~/types";

export type ShowPageData = {
	page: PageId;
	data: string; //pretty sure this is only used for inspectItem
	direct: boolean; // only used on jackpot
};
type Events = {
	showPage: ShowPageData;
	update: true | undefined; // bool true = shallow update
	"items-loaded": undefined;
};

export const game = new EventEmitter<Events>();
